export function isDigitalProduct(product: { productType: string }): boolean {
  // `digitalCard` = premium digital. `digital` = the synthetic free basic-digital
  // product (see `freeDigitalProduct`); the backend never returns a real `digital`
  // productType, so this only classifies that injected dummy. Both are digital.
  return product.productType === 'digitalCard' || product.productType === 'digital';
}
